<template>
  <section class="container">
    <div class="question">
      <div class="question__block">
        <!-- 分類導覽 -->
        <aside class="side">
          <el-radio-group
            v-model="QuestionCategoryId"
            @change="GetQuestionList()"
          >
            <ul class="side__list">
              <li
                v-for="item in QuestionCategories"
                :key="item.qaCategoryId"
                class="side__item"
              >
                <el-radio
                  class="side__button"
                  :label="item.qaCategoryId"
                >
                  {{ item.qaCategoryName }}
                </el-radio>
              </li>
            </ul>
          </el-radio-group>

          <el-select
            v-model="QuestionCategoryId"
            @change="GetQuestionList()"
          >
            <el-option
              v-for="item in QuestionCategories"
              :key="item.qaCategoryId"
              :label="item.qaCategoryName"
              :value="item.qaCategoryId"
            />
          </el-select>
        </aside>

        <!-- 主要內容 -->
        <div class="question-main">
          <ul class="question-article">
            <li class="question-article__list">
              <a
                v-for="questionItem in Questions"
                :key="questionItem.qaId"
                class="question-article__item"
              >
                <div class="question-article__title" @click="ToggleClass($event)">
                  <span>{{ questionItem.qaSubject }}</span>
                </div>

                <div class="question-article__content">
                  <p  v-html="questionItem.qaContent" />
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GetQuestionCategory, GetQuestionByCategoryId } from '@/api/QuestionApi';

/* global $ */
export default {
  data() {
    // 建立你的初始化 model data
    return {
      QuestionParam: {
        status: 1, // 將態為啟用
        qaCategoryId: 0, // 分類
      },
      Questions: [],
      QuestionCategories: [],
      QuestionCategoryId: 0,
    };
  },
  created() {
    this.GetQuestionCategoryList();
  },
  mounted() {},
  methods: {
    GetQuestionCategoryList() {
      GetQuestionCategory().then((response) => {
        if (response.data.statusCode === 0) {
          this.QuestionCategories = response.data.data;
          if (this.QuestionCategories.length > 0) {
            this.QuestionCategoryId = this.QuestionCategories[0].qaCategoryId;
            this.GetQuestionList();
          }
        }
      });
    },
    GetQuestionList() {
      this.QuestionParam.qaCategoryId = this.QuestionCategoryId;
      GetQuestionByCategoryId(this.QuestionParam).then((response) => {
        if (response.data.statusCode === 0) {
          this.Questions = response.data.data;
        }
      });
    },
    ToggleClass(event) {
      $(event.target)
        .closest('.question-article__item')
        .toggleClass('open')
        .find('.question-article__content')
        .toggle(300);
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  &__block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  &-main {
    width: calc(100% - 250px);

    @media (max-width: 991px) {
      width: 100%;
      margin-top: 20px;
    }
  }

  &-article {
    &__item {
      display: block;
      width: 100%;
      border-radius: 4px;
      background-color: #f7f7f7;
      transition-property: transform;
      transition-duration: .3s;
      transition-timing-function: linear;

      &:nth-child(n + 2) {
        margin-top: 12px;
      }

      &.open {
        .question-article__title {
          color: #fff;
          background-color: var(--primary-darken-color);

          &::before {
            color: #fff;
          }
        }
      }
    }

    &__title {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      padding: 15px;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      color: #333;

      &::before {
        content: "+";
        display: block;
        margin-right: 20px;
        font-size: 18px;
        font-weight: 700;
        line-height: 1;
        color: var(--primary-darken-color);
      }
    }

    &__content {
      display: none;
      width: 100% !important;
      padding: 15px 15px 15px 48px !important;
      font-size: 16px;
      color: #555;

      p {
        white-space: pre-wrap;
        max-height: 500px;
        overflow: auto;
      }
    }
  }
}
</style>
